import {
    get,
} from "@insite/client-framework/Services/ApiService";

const e4fipApiUrl = "api/v1/e4fip";

export async function getE4FIP(orderNumber: string) {
    const e4fipApiResponse = await (await get<any>(`${e4fipApiUrl}?OrderNumber=${orderNumber}`));
    return e4fipApiResponse;
}